import { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'hooks'
import {
  Nav,
  NavLink,
  NavLinkUnderline
} from './styles'

const NavRoutes = () => {
  const { t } = useTranslation()

  const { isCreators, isSeries, isCommunity } = useLocation()

  const [underlineOffset, setUnderlineOffset] = useState(null)

  const underlineRef = useRef()
  const navRef = useRef()
  
  const isUnderlineVisible = isSeries || isCommunity

  const calculateUnderlinePosition = (active) => {
    const underlineWidth = underlineRef.current.offsetWidth
    const offset = (active.offsetWidth - underlineWidth) / 2
    const start = active.offsetLeft
    const position = start + offset
    setUnderlineOffset(position)
  }

  useLayoutEffect(() => {
    if (isCreators) return
    const { active } = navRef.current.children
    if (active) calculateUnderlinePosition(active)

    const calc = () => {
      const { active } = navRef.current.children
      if (active) calculateUnderlinePosition(active)
    }

    window.addEventListener('resize', calc)
    return () => window.removeEventListener('resize', calc)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navRef.current, isCreators, isSeries, isCommunity])


  return (
    <Nav ref={navRef}>
      <NavLink
        id={isSeries ? 'active' : ''}
        $isActive={isSeries}
        to='/series'
      >
        {t('series')}
      </NavLink>

      <NavLink
        id={isCommunity ? 'active' : ''}
        $isActive={isCommunity}
        to='/community'
      >
        {t('community')}
      </NavLink>

      {isUnderlineVisible && (
        <NavLinkUnderline
          ref={underlineRef}
          offset={underlineOffset}
        />
      )}
    </Nav>
  )
}

export default NavRoutes